/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import { get } from 'lodash';
import { initTaskCompletion, submitTaskCompletionItem, completeGetNext } from '@/api';
import { TASK_COMPLETION_LIST, SET_KARMA_POINTS } from '@/store/mutation-types';

const state = {
  task_completion_list: [],
  question_type_index_array: [],
  completion_id: null,
  karma_points: 0,
  task_data: {},
};


const getters = {
  taskCompletionList(state) {
    return state.task_completion_list;
  },
  questionTypeIndexArray(state) {
    return state.question_type_index_array;
  },
  karmaPoints(state) {
    return state.karma_points;
  },
  taskAnonymous(state) {
    return state.task_data.task_allow_anon;
  },
};


const actions = {
  getCompletionItems({ commit }, values) {
    const userToken = this.getters['auth/userToken'];
    initTaskCompletion(userToken, values)
      .then(({ data }) => {
        const questionTypeIndexArray = [0];
        const taskCompletionList = get(data, '[1].data.details.task_completion_list', []);
        const taskData = get(data, '[1].data.details.task_data[0].task_data', {});
        const completionId = get(data, '[1].data.details.completion_id');
        for (let i = 0; i < taskCompletionList.length; i += 1) {
          const typeId = parseInt(taskCompletionList[i].task_completion_type_id, 10);
          questionTypeIndexArray.push(typeId);
        }
        questionTypeIndexArray.push(12);
        commit(TASK_COMPLETION_LIST,
          { taskCompletionList, questionTypeIndexArray, completionId, taskData });
      });
  },
  submitTaskCompletionItem({ state }, values) {
    // console.log(commit);
    const userToken = this.getters['auth/userToken'];
    submitTaskCompletionItem(userToken, { completion_id: state.completion_id, ...values })
      .then(() => {
        this.dispatch('completionQuestions/completeGetNext');
      });
  },
  completeGetNext({ commit, state }) {
    const userToken = this.getters['auth/userToken'];
    completeGetNext(userToken, state.completion_id)
      .then(({ data }) => {
        const completed = get(data, '[1].data.details.completed') || 0;
        if (completed === 1) {
          const karma = get(data, '[1].data.details.user_karma');
          commit(SET_KARMA_POINTS, karma);
        }
      });
  },
};


const mutations = {
  [TASK_COMPLETION_LIST](state, {
    taskCompletionList, questionTypeIndexArray, completionId, taskData }) {
    state.task_completion_list = [...taskCompletionList];
    state.question_type_index_array = questionTypeIndexArray;
    state.completion_id = completionId;
    state.task_data = { ...taskData };
  },
  [SET_KARMA_POINTS](state, karmaPoints) {
    state.karma_points = karmaPoints;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/completion_questions.js